import * as React from 'react';
import { isEmpty } from 'lodash';

import InfluencerPosts from './InfluencerPosts';
import ChannelHeader from './channels/ChannelHeader';
import ChannelLatestPosts from './channels/ChannelLatestPosts';

import { t } from 'utils/language';
import { NUM_POSTS_VISIBLE, getMostEngagedPosts, getMostRecentPosts, hasMetrics } from 'utils/influencers';
import { getMetricValue } from 'utils/helper/common';

import type { Channel, InfluencerProfile, Metrics } from 'types';

type Props = {
  influencerProfile: InfluencerProfile,
  selectedChannel: Channel | undefined | null,
  channelType: string,
  haveMetricsBeenGathered: boolean,
  isFreemium: boolean | null | undefined
};

class InfluencerChannelsCard extends React.PureComponent<Props> {
  getMetrics(selectedChannel?: Channel | null): Metrics {
    return selectedChannel && selectedChannel.metrics ? selectedChannel.metrics : {};
  }

  renderTopPosts(): React.ReactNode | undefined | null {
    const { selectedChannel, influencerProfile, channelType, haveMetricsBeenGathered, isFreemium } = this.props;
    const mostEngagedPosts = getMostEngagedPosts(influencerProfile, channelType);

    const recentPosts = (influencerProfile.mostRecentPosts || {})[channelType] || [];

    if (selectedChannel && channelType) {
      return (
        <div className="influencer-channels-card__posts">
          <ChannelHeader
            hasRecentPosts={Boolean(recentPosts.length)}
            hasActiveFbConnection={Boolean(influencerProfile.hasActiveFbConnection)}
            channel={selectedChannel}
            showFallback={haveMetricsBeenGathered && !hasMetrics(selectedChannel)}
            benchmarksResource={influencerProfile.benchmarksResource}
            isFreemium={isFreemium}
          />
          {
            !isEmpty(mostEngagedPosts) && (
              <InfluencerPosts
                key={t(`influencer_engaged_${channelType}_title`)}
                title={t(`influencer_engaged_${channelType}_title`)}
                posts={mostEngagedPosts}
                numImages={NUM_POSTS_VISIBLE[channelType]}
                numFollowers={getMetricValue(this.getMetrics(selectedChannel), 'followers')}
                channelType={channelType}
              />
            )
          }
        </div>
      );
    }

    return null;
  }

  renderRecentPosts(): React.ReactNode {
    const { selectedChannel, influencerProfile, channelType } = this.props;
    const mostRecentPosts = getMostRecentPosts(influencerProfile, channelType);
    return (
      <ChannelLatestPosts
        key={channelType}
        influencerProfile={influencerProfile}
        channel={selectedChannel}
        channelType={channelType}
        count={NUM_POSTS_VISIBLE[channelType]}
        numFollowers={getMetricValue(this.getMetrics(selectedChannel), 'followers')}
        posts={mostRecentPosts}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <div className="influencer-channels-card">
        {this.renderTopPosts()}
        {this.renderRecentPosts()}
      </div>
    );
  }
}

export default InfluencerChannelsCard;
